var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.95 12.1838L29.296 12.3863C29.9774 12.785 30.2109 13.6682 29.8175 14.3588L26.8749 19.5243C26.4814 20.215 25.61 20.4516 24.9286 20.0529L24.5825 19.8504C23.6454 19.302 23.0145 18.3417 22.8769 17.2539C22.7775 16.4685 21.954 16.0072 21.2449 16.3397L20.3519 16.7586C19.9853 16.9305 19.5592 16.9111 19.2093 16.7064L13.9989 13.9927C13.4906 13.6953 13.2572 13.0779 13.4392 12.5123L13.8301 10.8814C13.9514 10.5043 13.7981 10.0855 13.4392 9.92769C10.5736 8.66744 6.27563 10.6358 6.27563 8.45972C6.27563 6.28365 13.4973 3.47713 18.2937 6.28367L23.5783 9.04066C23.9281 9.24535 24.1563 9.6088 24.1927 10.0165L24.2813 11.0097C24.3516 11.7983 25.1576 12.2905 25.8784 11.9851C26.8768 11.5619 28.0128 11.6355 28.95 12.1838Z",
    stroke: "#707070",
    strokeWidth: 2.13545
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6492 13.6444L5.52857 28.0471C5.13908 28.6518 5.33049 29.464 5.9476 29.8251L8.21429 31.1514C8.8314 31.5125 9.62111 31.2744 9.94313 30.6302L18.0171 15.9502",
    stroke: "#707070",
    strokeWidth: 2.13545
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(4.5 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCis);
export default __webpack_public_path__ + "static/media/cis.4f7bf2c37bfbc28718b18efe20f235e3.svg";
export { ForwardRef as ReactComponent };